import axios from 'axios';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { allowScroll, preventScroll } from '../../common/utils';
import MarketStep1 from './MarketStep1';
import { useState } from 'react';
import MarketStep2 from './MarketStep2';
import MarketStep3 from './MarketStep3';
import MarketStep4 from './MarketStep4';

export default function MarketRegistration({ getSelectedData, getIsSlideModal }) {
	const [counter, setCounter] = useState(0);
	const [SelectedData, setSelectedData] = useState({
		market: '',
		marketID: '',
		taskName: '',
		template: '',
		scrap: '',
	});
	const [Market, setMarket] = useState(null);
	const [MarketID, setMarketID] = useState(null);
	const [TaskName, setTaskName] = useState(null);
	const [Template, setTemplate] = useState(null);
	const [Scrap, setScrap] = useState(null);
	const [ShowLeftBtn, setShowLeftBtn] = useState(false);
	const [ShowRightBtn, setShowRightBtn] = useState(true);
	const [DisabledRightBtn, setDisabledRightBtn] = useState(false);
	const [DisabledTaskRegistrationBtn, setDisabledTaskRegistrationBtn] = useState(false);
	const [RegIdx, setRegIdx] = useState(null);

	const handleLeftBtnClick = () => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(
			'이전 단계로 돌아갈 시 현재 단계에서 선택한 내용이 사라집니다.'
		);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			if (counter > 0) {
				setCounter(counter - 1);
				if (counter === 1) {
					const updatedSelectedData = { ...SelectedData, template: '' };
					setSelectedData(updatedSelectedData);
					getSelectedData(updatedSelectedData);
				}
				if (counter === 2) {
					const updatedSelectedData = { ...SelectedData, scrap: '' };
					setSelectedData(updatedSelectedData);
					getSelectedData(updatedSelectedData);
				}
			}
		}
	};
	const handleRightBtnDisabled = (updatedSelectedData) => {
		if (
			counter === 0 &&
			updatedSelectedData.market &&
			updatedSelectedData.marketID &&
			updatedSelectedData.taskName &&
			updatedSelectedData.taskName.length > 0
		) {
			setDisabledRightBtn(false);
		} else {
			setDisabledRightBtn(true);
		}
		if (counter === 1 && updatedSelectedData.template)
			setDisabledRightBtn(false);
	};
	const handleTaskRegistrationBtnDisabled = (updatedSelectedData) => {
		if (counter === 2 && updatedSelectedData.scrap)
			setDisabledTaskRegistrationBtn(false);
	};
	const handleRightBtnClick = () => {
		if (counter < 4) setCounter(counter + 1);
	};
	const handleTaskRegistrationBtnClick = () => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(`작업줄에 추가 하시겠습니까?`);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			// TODO:: 작업줄 추가 API
			axios({
				method: 'POST',
				url: `${window.location.protocol}//${window.location.hostname}:3001/makeRegWork`,
				data: {
					token: localStorage.getItem('token'),
					marketCode: SelectedData.market,
					loginId: SelectedData.marketID,
					title: SelectedData.taskName,
					templateIdx: SelectedData.template,
					bookmarkIdx: SelectedData.scrap
				},
				xhrFields: {
					withCredentials: true,
				},
			})
				.then(res => {
					console.log(res);
					if (res.data?.idx) {
						setRegIdx(res.data.idx);
						handleRightBtnClick();
					}
				})
		}
	};
	const handleRegistrationBtnClick = () => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(`마켓에 등록 하시겠습니까?`);
		/* eslint-enable no-restricted-globals */
		if (isOk && RegIdx) {
			// TODO:: 마켓등록 API
			axios({
				method: 'POST',
				url: `${window.location.protocol}//${window.location.hostname}:3001/spread`,
				data: {
					token: localStorage.getItem('token'),
					mode: 'register',
					idx: RegIdx,
					marketId: SelectedData.marketID,
					marketCode: SelectedData.market
				},
				xhrFields: {
					withCredentials: true,
				},
			})
			getIsSlideModal(false);
		}
	};

	useEffect(() => {
		setDisabledRightBtn(true);
		handleRightBtnDisabled(SelectedData);
		if (counter === 0) {
			setShowLeftBtn(false);
			setShowRightBtn(true);
		}
		if (counter === 1) {
			setShowLeftBtn(true);
			setShowRightBtn(true);
		}
		if (counter === 2) {
			setDisabledTaskRegistrationBtn(true);
			setShowLeftBtn(true);
			setShowRightBtn(false);
		}
		if (counter === 3) {
			setShowLeftBtn(false);
			setShowRightBtn(false);
		}
	}, [counter]);

	useEffect(() => {
		const updatedSelectedData = { ...SelectedData, market: Market };
		setSelectedData(updatedSelectedData);
		getSelectedData(updatedSelectedData);
		handleRightBtnDisabled(updatedSelectedData);
	}, [Market]);
	useEffect(() => {
		const updatedSelectedData = { ...SelectedData, marketID: MarketID };
		setSelectedData(updatedSelectedData);
		getSelectedData(updatedSelectedData);
		handleRightBtnDisabled(updatedSelectedData);
	}, [MarketID]);
	useEffect(() => {
		const updatedSelectedData = { ...SelectedData, taskName: TaskName };
		setSelectedData(updatedSelectedData);
		getSelectedData(updatedSelectedData);
		handleRightBtnDisabled(updatedSelectedData);
	}, [TaskName]);
	useEffect(() => {
		const updatedSelectedData = { ...SelectedData, template: Template };
		setSelectedData(updatedSelectedData);
		getSelectedData(updatedSelectedData);
		handleRightBtnDisabled(updatedSelectedData);
	}, [Template]);
	useEffect(() => {
		const updatedSelectedData = { ...SelectedData, scrap: Scrap };
		setSelectedData(updatedSelectedData);
		getSelectedData(updatedSelectedData);
		handleTaskRegistrationBtnDisabled(updatedSelectedData);
	}, [Scrap]);

	useEffect(() => {
		const prevScrollY = preventScroll();
		return () => {
			allowScroll(prevScrollY);
		};
	}, []);
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1, transition: { duration: 0.2 } }}
			exit={{ opacity: 0, transition: { delay: 0.1, duration: 0.1 } }}
			className='marketRegistrationModal'
		>
			<motion.div
				initial={{ x: 100 }}
				animate={{ x: 0, transition: { duration: 0.3 } }}
				exit={{ x: 100, transition: { duration: 0.2 } }}
			>
				<div className='slide-modal-content'>
					<div className='counters'>
						<span className={counter === 0 ? 'on' : ''}>1</span>
						<em className={counter === 0 ? 'on' : ''}></em>
						<span className={counter === 1 ? 'on' : ''}>2</span>
						<em className={counter === 1 ? 'on' : ''}></em>
						<span className={counter === 2 ? 'on' : ''}>3</span>
						<em className={counter === 2 ? 'on' : ''}></em>
						<span className={counter === 3 ? 'on' : ''}>4</span>
					</div>
					<div className='slides'>
						{counter === 0 && (
							<MarketStep1
								selectedData={SelectedData}
								getMarket={setMarket}
								getMarketID={setMarketID}
								getTaskName={setTaskName}
							/>
						)}
						{counter === 1 && (
							<MarketStep2
								Market={SelectedData.market}
								selectedData={SelectedData}
								getTemplate={setTemplate}
							/>
						)}
						{counter === 2 && <MarketStep3 selectedData={SelectedData} getScrap={setScrap} />}
						{counter === 3 && <MarketStep4 selectedData={SelectedData} />}
					</div>
					<div className='buttons'>
						{ShowLeftBtn && (
							<button
								name='left'
								className='leftBtn'
								onClick={() => handleLeftBtnClick()}
							>
								이전
							</button>
						)}
						{ShowRightBtn && (
							<button
								name='right'
								className='rightBtn'
								onClick={() => handleRightBtnClick()}
								disabled={DisabledRightBtn}
							>
								다음
							</button>
						)}
						{counter === 2 && (
							<button
								name='taskRegistration'
								className='taskRegistrationBtn'
								onClick={() => handleTaskRegistrationBtnClick()}
								disabled={DisabledTaskRegistrationBtn}
							>
								작업줄 생성버튼
							</button>
						)}
						{counter === 3 && (
							<button
								name='registration'
								className='registrationBtn'
								onClick={() => handleRegistrationBtnClick()}
							>
								등록
							</button>
						)}
					</div>
				</div>
			</motion.div>
		</motion.div>
	);
}
